import { useLanguageAndThemeFromURL as useNativeuseLanguageAndThemeFromURL } from '@libs/hooks';
import { useThemeMode } from './useThemeMode';
import { useTranslation } from './useTranslation';

export const useLanguageAndThemeFromURL = () => {
  const { changeLanguage } = useTranslation();
  const { selectTheme } = useThemeMode();
  return useNativeuseLanguageAndThemeFromURL(changeLanguage, selectTheme);
};
